module.exports = __webpack_public_path__ + "static/img/claim-step-2.f844943.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-step-2.svg
// module id = 94Cg
// module chunks = 1